import { BACKEND_URL as host } from '../../core/env';

export default async function getCurrentApiV3Version() {
  const response = await fetch(`${host}/apiversion`);
  return response.json();
}
